export const CONTEXTO = 'CONTEXTO';
export const AVATAR_BASE64 = 'AVATAR_BASE64';
export const SNACKBAR = 'SNACKBAR';
export const NOTIFICATION = 'NOTIFICATION';
export const CLEAR_STATE = 'CLEAR_STATE';
export const SET_TIPO_AGENDA = 'SET_TIPO_AGENDA';
export const SET_FILTRO_VENDA = 'SET_FILTRO_VENDA';
export const SET_FILTRO_COMPRA = 'SET_FILTRO_COMPRA';
export const SET_FILTRO_LOTE = 'SET_FILTRO_LOTE';
export const LOCALIZACAO = 'LOCALIZACAO';

export const SET_ITEMS = 'SET_ITEMS';
export const UNSET_ITEMS = 'UNSET_ITEMS';
export const ITEMS_ADD = 'ITEMS_ADD';
export const ITEMS_DEL = 'ITEMS_DEL';
export const LOTE_ADD = 'LOTE_ADD';
export const LOTE_DEL = 'LOTE_DEL';
